import "../../styles/disclaimer.css";

export default function DisclaimerBanner({
    message,
    height = 44,
}) {
    if (!message) return null;

    return (
        <div
            className="disclaimer-banner"
            role="status"
            aria-live="polite"
            style={{ "--disclaimer-banner-height": `${height}px` }}
        >
            <div className="disclaimer-banner__inner">
                <span className="disclaimer-banner__text">{message}</span>
            </div>
        </div>
    );
}